import { createFileRoute, redirect, useParams } from "@tanstack/react-router";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { LangProvider } from "../contexts/LangContext";
import { ChatPage } from "../pages/ChatPage";

const allowedLanguages = ["oz", "uz", "ru", "en"];

export const Route = createFileRoute("/$lang/chat")({
  head: ({ params }) => {
    const titleMap: Record<string, string> = {
      oz: "Chat — Lotin.uz",
      uz: "Чат — Lotin.uz",
      ru: "Чат — Lotin.uz",
      en: "Chat — Lotin.uz",
    };
    return {
      meta: [{ title: titleMap[params.lang] || titleMap.oz }],
    };
  },
  beforeLoad: ((ctx: { params: { lang: string } }) => {
    const { params } = ctx;
    if (!allowedLanguages.includes(params.lang)) {
      throw redirect({ to: "/chat" });
    }
    if (params.lang === "oz") {
      throw redirect({ to: "/chat" });
    }
  }) as any,
  component: Chat,
});

function Chat() {
  const { lang } = useParams({ from: "/$lang/chat" });
  const { i18n } = useTranslation();

  useEffect(() => {
    const langMap: Record<string, string> = {
      oz: "uz-Latn",
      uz: "uz-Cyrl",
      ru: "ru",
      en: "en-US",
    };
    document.documentElement.lang = langMap[lang] || "uz-Latn";
    if (i18n?.changeLanguage) {
      i18n.changeLanguage(lang);
    }

    const titleMap: Record<string, string> = {
      oz: "Chat — Lotin.uz",
      uz: "Чат — Lotin.uz",
      ru: "Чат — Lotin.uz",
      en: "Chat — Lotin.uz",
    };
    document.title = titleMap[lang] || titleMap.oz;
  }, [lang, i18n]);

  const langMapForContext: Record<string, string> = {
    oz: "uz-Latn",
    uz: "uz-Cyrl",
    ru: "ru",
    en: "en-US",
  };

  return (
    <LangProvider lang={langMapForContext[lang] || "uz-Latn"}>
      <ChatPage />
    </LangProvider>
  );
}
